import { LockClosedIcon } from "@heroicons/react/24/outline";

interface NoAccessProps {
  title?: string;
  description?: string;
}

/** Shown in place of a page the current user is not allowed to use. */
const NoAccess = ({
  title = "You don't have access to this page",
  description = "Ask an admin on your business account if you think you should have access.",
}: NoAccessProps) => (
  <div className="flex flex-col items-center justify-start min-h-screen px-4 pt-16 text-center bg-gray-50">
    <div className="w-32 h-32 mx-auto mb-6 bg-gray-100 rounded-full flex items-center justify-center">
      <LockClosedIcon className="w-16 h-16 text-gray-500" aria-hidden="true" />
    </div>
    <h1 className="text-3xl font-bold mb-4 text-gray-800">{title}</h1>
    <p className="text-gray-600 max-w-md mb-6 text-lg">{description}</p>
  </div>
);

export default NoAccess;
